import { List, ListItem } from "@mui/material";
import { Length } from "../../services/RuteplanAPI";
import { IRoutePartProps } from "./RouteDescription";

export default function LengthRestrictions(props: IRoutePartProps) {
    
    return (        
        <>
            {props.roadFeatures && props.roadFeatures.lengths && props.roadFeatures.lengths.length > 0 &&
            <List style={{paddingTop: "0px", paddingBottom:"0px"}}>
                {props.roadFeatures.lengths.map( (lengthRestriction: Length, index: number) => (
                    <ListItem 
                    style={{paddingTop: "0px", paddingBottom:"0px", color:"gray"}} 
                    key={lengthRestriction.maxLength + index} 
                    className="roadFeature" 
                    onClick={(event) => {props.onClick(lengthRestriction, event)}}
                    onMouseEnter={() => props.onMouseEnterItem(lengthRestriction)}
                    onMouseLeave={props.onMouseLeaveItem}
                    >
                    Maks lengde: {lengthRestriction.maxLength}m
                    </ListItem>
                ))}
            </List>        
            }
        </>
    )

}